import {Component, OnInit} from '@angular/core';
import {User} from '../../../models/user.model';
import {UserService} from '../../../services/user.service';
import {TimeFormatterService} from '../../../services/time-formatter.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeModalComponent } from './change-modal/change-modal.component';
import { AdminService } from '../../../services/admin.service';
import { NgbCalendar} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-user-report',
  templateUrl: './view-user-report.component.html',
  styleUrls: ['./view-user-report.component.css']
})
export class ViewUserReportComponent implements OnInit {
  private user: User;
  userAPI;
  public isLoaded = false;
  public errorInfo = false;
  isAdmin = false;
  host;
  isAdmins = false;
	isUser = false;
	isHead = false;
  visible = '';
  obj;
  suc = false;

  constructor(private userService: UserService,
              private modalService: NgbModal,
                private router: Router,
              private adminService: AdminService) {
                this.host = location.origin;;
              }
  

  ngOnInit() {
    this.isAdmin = false;
    this.user = this.userService.getLocal();

    this.userService.getUserFromAPI(this.user.id).subscribe(
      (response) => {
        const data = response.body;
        this.userAPI = data;

        this.userAPI.roles.forEach(role => {
          if (role === 'ADMIN') {
            this.isAdmin = true;
          }
        });

        this.isLoaded = true;
        this.errorInfo = false;

      },
      () => {
        this.isLoaded = true;
        this.errorInfo = true;
      },
      () => {
     
      });

      this.user = this.userService.getLocal();
      if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
        this.isAdmins = true;
      } else {
        this.isAdmins = false;
      }
      if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
        this.isHead = true;
      } else {
        this.isHead = false;
      }
      if (this.user.roles.indexOf('ROLE_USER') !== -1) {
        this.isUser = true;
      } else {
        this.isUser = false;
      }

      if(!this.isAdmins) {
        this.router.navigate(['/dashboard']);
      }

      this.renameGroup();
  }


  renameGroup() {
    this.adminService.getModalSetting().subscribe(
        (res: any) => {
          this.obj = res.body;
        }
      );
  }

  openEdit(action, title, value) {
    const modalRef = this.modalService.open(ChangeModalComponent);
    modalRef.componentInstance.action = action;
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.obj = this.obj;
    modalRef.componentInstance.value = value;
    modalRef.result.then((result) => {
			if (result === 'ok') {
        this.suc = true;
				setTimeout(() => this.suc = false, 2000);
				this.renameGroup();
			}
		});
  }

  vis(action) {
    this.visible = action;
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/view-user-report/view-user-report.component.ts